import { IEnvironment } from './environment.interface';

export const environment: IEnvironment = {
  production: true,
  defaultLoadingMessage: 'Loading data, please wait...'
};
